export const Recommended = () => {
  return (
    <>
      Recommended
    </>
  )
}